<template>
  <v-dialog
    ref="dialog"
    v-model="modal"
    width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        prepend-inner-icon="mdi-calendar"
        :value="dateFormated"
        readonly
        v-on="on"
        :outlined="!$attrs.filled"
        @click:clear="$emit('input', [])"
        append-icon="mdi-chevron-down"
        dense
        v-bind="$attrs"
        @click:append="modal = true"
      >
      </v-text-field>
    </template>
    <v-date-picker
      :value="value"
      @input="input => $emit('input', input)"
      v-bind="$attrs"
      locale="pt-br"
      range
    >
    </v-date-picker>
  </v-dialog>
</template>

<script>
import moment from 'moment'

export default {
  props: ['value'],
  computed: {
    dateFormated () {
      if (this.value.filter(item => item).length !== 2) {
        return ''
      }

      const start = this.value[0] && moment.utc(this.value[0]).format('DD/MM')
      const end = this.value[1] && moment.utc(this.value[1]).format('DD/MM')
      return `${start} até ${end || 'aguardando'}`
    }
  },
  data () {
    return {
      modal: false
    }
  }
}
</script>
